export const disableActionsByDefault = (columnId: string) => {
  return (
    columnId === 'centro-codigo' ||
    columnId === 'produto-id' ||
    columnId === 'parametros-tipo-suprimentos' ||
    columnId === 'parametros-emax' ||
    columnId === 'parametros-frequencia-pedidos' ||
    columnId === 'parametros-lead-time' ||
    columnId === 'parametros-lote-multiplo' ||
    columnId === 'politica-arbritada' ||
    columnId === 'parametros-lote-minimo-cd' ||
    columnId === 'parametros-estoque-minimo'
  )
}
